module.exports = __webpack_public_path__ + "static/media/TitlesBadOptimized.7ef550a0.jp2";